import React from "react";
import { LayoutGrid } from "lucide-react";
import { getCategoryIcon } from "../../utils/iconHelper";
import "../../styles/sectionPage.css";

/**
 * Presentational component to render the categories scrollable list/grid.
 * Supports desktop wrap and mobile horizontal single-row scroll.
 * @param {Object} props
 * @param {Array} props.categories - Array of category documents belonging to this section
 * @param {string} props.selectedCategory - The currently active category selection name
 * @param {Function} props.setSelectedCategory - State modifier function
 * @param {string} props.sectionColor - Accent color for active highlighting
 */
const SectionCategories = ({
  categories = [],
  selectedCategory = "All",
  setSelectedCategory,
  sectionColor,
  counts = {},
}) => {
  const categoriesStyle = {
    "--section-color": sectionColor || "#ff6a00",
    "--section-color-glow": sectionColor && sectionColor.startsWith("#") ? `${sectionColor}4d` : "rgba(255, 255, 255, 0.3)",
  };

  return (
    <div className="categories-section" style={categoriesStyle}>
      <h2 className="categories-section-title">Categories In This Section</h2>
      <div className="categories-row">
        {/* All Categories Chip */}
        <div
          className={`category-chip ${selectedCategory === "All" ? "selected" : ""}`}
          onClick={() => setSelectedCategory("All")}
        >
          <LayoutGrid className="category-chip-icon" size={18} strokeWidth={1.75} />
          <span>All ({counts["All"] || 0})</span>
        </div>

        {/* Section Specific Category Chips */}
        {categories.map((category) => {
          const CategoryIcon = getCategoryIcon(category.name);
          const isSelected = selectedCategory === category.name;
          const count = counts[category._id] || 0;

          return (
            <div
              key={category._id || category.name}
              className={`category-chip ${isSelected ? "selected" : ""}`}
              onClick={() => setSelectedCategory(category.name)}
            >
              <CategoryIcon className="category-chip-icon" size={18} strokeWidth={1.75} />
              <span>{category.name} ({count})</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SectionCategories;
